// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"not-found_shadow__dtUhs","link":"not-found_link__2pI0v"};